import { z } from 'my-zod'
import { outfitterDocumentSystemView } from './outfitter-document-system-view'

export const outfitterDocumentAdminView = outfitterDocumentSystemView
  .augment({
    attachment: outfitterDocumentSystemView.shape.attachment.nullable()
  })
  .setCFV({
    ...outfitterDocumentSystemView.getCFV(),
    attachmentRequired(val) {
      if (!val.attachment) {
        return {
          message: 'Required',
          path: ['attachment']
        }
      }
    }
  })

export type outfitterDocumentAdminView = z.infer<typeof outfitterDocumentAdminView>
